import { render, staticRenderFns } from "./gsjj.vue?vue&type=template&id=76a062a4&scoped=true"
import script from "./gsjj.vue?vue&type=script&lang=js"
export * from "./gsjj.vue?vue&type=script&lang=js"
import style0 from "./gsjj.vue?vue&type=style&index=0&id=76a062a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a062a4",
  null
  
)

export default component.exports